import React from "react";
import { Icon } from "./Icon";

interface AlertTriangleProps {
  size?: number;
  className?: string;
  color?: string;
}

export const AlertTriangle: React.FC<AlertTriangleProps> = ({
  size,
  className,
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M496.507 367.349c17.135 0 31.030 13.892 31.030 31.030v204.471c0 17.135-13.895 31.030-31.030 31.030-17.138 0-31.030-13.895-31.030-31.030v-204.471c0-17.138 13.892-31.030 31.030-31.030z" />
      <path d="M188.955 791.217c-6.873 13.753 3.129 29.935 18.505 29.935h578.025c15.376 0 25.38-16.182 18.506-29.935l-289.013-578.368c-7.621-15.253-29.389-15.253-37.010 0l-289.014 578.368zM570.492 185.108l289.013 578.368c27.493 55.017-12.515 119.737-74.020 119.737h-578.025c-61.505 0-101.513-64.72-74.020-119.737l289.013-578.368c30.487-61.012 117.552-61.012 148.039 0z" />
      <path d="M539.775 705.092c0 23.915-19.388 43.303-43.303 43.303s-43.303-19.388-43.303-43.303c0-23.915 19.388-43.303 43.303-43.303s43.303 19.388 43.303 43.303z" />
    </Icon>
  );
};
